import {
  type TypedUseSelectorHook,
  useDispatch,
  useSelector,
} from 'react-redux'
import { type AppDispatch, type RootState } from 'src/libs'

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelect: TypedUseSelectorHook<RootState> = useSelector
